<template>
  <div class="unitPage" >
  <p class="courseName">WELLCOME TO **{{courseName}}**</p>
  <div class="backgroundImage" :class="{'switchStyle':switchSwiperStatus}">
    <img :src="backgroundImage" alt="">
  </div>
  <div class="contentMain" :class="{'switchStyle':switchSwiperStatus}">
    <h1 class="unitName">{{ openDeatils.unitName || courseName }}</h1>
    <p v-html="openDeatils.unitIntro" style="height: 60%;"></p>
    <div class="goButton" @click="toCourse(openDeatils)">进入课程</div>
  </div>
  <div class="swiperMain">
    <swiper ref="mySwiper" :options="swiperOptions" style="height: 453px" class="swiper-wrappe carousel">
        <swiper-slide class="swiper-slide"  v-for="(b,i) in courseUnitDataSource" :key="i">
            <div class="swiper-slide-unit"><img :src="b.unitCover_url" alt=""></div>
        </swiper-slide>
    </swiper>
  </div>
  <div class="unitFooter">
      <div v-show="courseUnitDataSource && courseUnitDataSource.length > 1" class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
  </div>
  </div>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
import UnitViewModal from '@/components/course/UnitViewModal'
export default {
  name: '',
  components: {UnitViewModal},
  data() {
    return {
        departId:'',
        courseId:'',
        courseName:'',
        courseUnitDataSource:[],
        openDeatils:null,
        swiperOptions:{
            initialSlide:0,
            autoplay:false,
            speed: 800,
            observer: true,
            observeParents: true,
            centeredSlides: false,
            slidesPerView: 3, // 大于900像素时显示3个幻灯片
            spaceBetween: 0,  // 可选：设置间距
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            loop: true,
            // breakpoints: {
            //     920: {  //当屏幕宽度小于等于1280
            //         slidesPerView: 2,
            //         spaceBetween: 20
            //     },
            //     768: {  //当屏幕宽度小于等于768
            //         slidesPerView: 1,
            //         spaceBetween: 20,
            //     },
            // },
            on: {
                init: function (swiper) {
                    console.log(this.realIndex , '当前激活索引' , this)
                },
                slideChange :()=> {
                    const swiper = this.$refs.mySwiper.$swiper;
                    this.updateActiveIndex(swiper.realIndex)
                },
            },
        },
        backgroundImage:'',
        switchSwiperStatus:false,
    }
  },
  created() {
    let query = this.$route.query
    console.log(query , 'query')
    this.departId = query.departId
    this.courseId = query.courseId
    this.courseName = query.courseName
    this.getList()
  },
  mounted() {},
  watch:{

  },
  methods: {
    toCourse(unit){
      // if(!unit.departId){
      //   this.$message.info('本课程仅做展示，请从个人中心进入课程')
      //   return
      // }
      console.log(unit);
      if(unit.isUnitOpen == 0 || (unit.isUnitOpen == 2 && unit.openTime > unit.serverTime)){
        this.$message.info("未开课")
        return
      }
      this.$store.commit('SET_UNITOBJ',unit)
      this.$router.push({path:'/courseUnitModel',query:{id:unit.id,courseId:this.courseId,type:4}})
    },
    updateActiveIndex(index) {
   
    this.switchSwiperStatus  = true
    let timer = setTimeout(()=>{
      this.openDeatils = this.courseUnitDataSource[index]
      this.backgroundImage = JSON.parse(this.courseUnitDataSource[index].showConfig).backgrounImage ? JSON.parse(this.courseUnitDataSource[index].showConfig).backgrounImage[0].filePath : ''
      this.switchSwiperStatus = false
      clearTimeout(timer)
    },1000)
    this.$forceUpdate()
    },
    getList() {
      if (this.departId) {
        getAction("/teaching/teachingCourseUnit/mineUnit", {
          courseId: this.courseId,
          departId: this.departId,
        }).then((res) => {
          if (res.success) {
            this.courseUnitDataSource = res.result.records;
          }
        });
      } else {
        getAction("/teaching/teachingCourseUnit/showCourseUnit", {
          courseId: this.courseId,
        }).then((res) => {
          if (res.success) {
            this.courseUnitDataSource = res.result;
            this.openDeatils = res.result[0];
            this.backgroundImage = JSON.parse(res.result[0].showConfig).backgrounImage ? JSON.parse(res.result[0].showConfig).backgrounImage[0].filePath : ''
            console.log(JSON.parse(res.result[0].showConfig).backgrounImage[0].filePath  , '背景图 ')

          }
        });
      }
    },
  }
}
</script>
<style lang='less' scoped>
/deep/.swiper-pagination-bullet{
    background: #fff !important;
    opacity: 0.8 !important;
    margin: 0 8px !important;
}
/deep/.swiper-pagination-bullet-active{
    background: var(--primary-color) !important;
}
.swiper-slide-active{
   .swiper-slide-unit{
        width: 280px !important;
        height: 80% !important;
        border: 4px solid #fff;
        margin: 0 auto !important;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
  }
  .swiper-slide{
    display: flex;
    align-items: flex-end;
  }
.unitPage{
    width: 100%;
    height: calc(100vh - 67px);
    position: relative;
    .backgroundImage{
      transition: opacity 0.5s ease-in-out; 
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      opacity: 1;
      &.switchStyle {
        opacity: 0; // 切换时透明
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
    .courseName{
      width: auto;
      height: 60px;
      background: #00000040;
      border-radius: 30px;
      padding: 0 30px;
      position: absolute;
      top: 10px;
      left: 30px;
      z-index: 2;
      color: #fff;
      line-height: 60px;
      color: #fff;
      font-size: 24px;
    }
    .contentMain{
      transition: all 0.5s linear; 
      width: 40%;
      height: 550px;
      background: #00000040;
      backdrop-filter: blur(10px);
      border-radius:0 20px 20px 0;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: 0;
      z-index: 2;
      padding: 30px;
      opacity: 1;
      &.switchStyle {
        left: -1800px; // 切换时透明
      }
      .unitName{
            font-size: 48px;
            font-weight: bold;
            margin-bottom: 30px;
            color: #fff;
        }
      .goButton{
        width: 220px;
        height: 80px;
        background: var(--primary-color);
        border-radius: 40px;
        text-align: center;
        line-height: 80px;
        color: #fff;
        font-size: 34px;
        cursor: pointer;
        float: right;
      }
    }
    .swiperMain{
      width: 50%;
      position: absolute;
      right: 0;
      bottom: 50px;
      .swiper-slide-unit{
          width: 270px;
          height: 60%;
          margin: 0 auto;
          border-radius:10px;
          img{
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
          }
      }
    }
    .unitFooter{
          width: 100%;
          height: 50px;
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
      }
  .switchStyle{

  }
}
</style>
